import { gettaxDetails } from "../../config/apiConfig";
import {
  FETCH_TAXSETTING_BEGIN,
  FETCH_TAXSETTING_SUCCESS,
  FETCH_TAXSETTING_FAILURE
  } from '../constants/taxsetting';
import { sbaAxios } from "../utils/sbaAxios";


export const getTaxSettingFields=(taxYear)=> {
   return (dispatch) => {
    dispatch(fetchtaxSettingBegin());
    sbaAxios({url:`${gettaxDetails}${taxYear}`,method:"get"})
    .then((repos) => {
      const taxSetting = repos;
      dispatch(fetchtaxSettingSuccess(taxSetting));
      return taxSetting;
    })
    .catch((error) => dispatch(fetchtaxSettingFailure(error)));
  };
}

export const fetchtaxSettingBegin = () => ({
  type: FETCH_TAXSETTING_BEGIN,
});

export const fetchtaxSettingSuccess = (taxSetting) => ({
  type: FETCH_TAXSETTING_SUCCESS,
  payload: {taxSetting},
});


export const fetchtaxSettingFailure = (errorMessage) => ({
  type: FETCH_TAXSETTING_FAILURE,
  payload: {errorMessage}
});

